import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '../services';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description Angular Pipe to take markdown content and parse it into HTML on an async worker thread.
 * @see markdown-processor.ts
 */
@Pipe({
	name: 'adaMarkdown',
})
export class MarkdownPipe implements PipeTransform {

	protected readonly markdownService: MarkdownService = inject(MarkdownService);

	protected readonly sanitizer: DomSanitizer = inject(DomSanitizer);

	public transform(_markdown: string): SafeHtml {
		const _html: string = this.markdownService.syncParse(_markdown);

		if (_html)
			return this.sanitizer.bypassSecurityTrustHtml(_html);

		return _markdown;
	}

}
